import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

type AdminListSkeletonProps = {
  /** Number of row placeholders. */
  rows?: number
  /** Show a filter/toolbar bar above the list. */
  showToolbar?: boolean
  className?: string
}

/**
 * Default list loading state for ops pages (users, reports, banners, …).
 * Prefer this over plain "Loading…" text.
 */
export function AdminListSkeleton({
  rows = 6,
  showToolbar = true,
  className,
}: AdminListSkeletonProps) {
  return (
    <div
      className={cn('flex flex-col gap-3', className)}
      role="status"
      aria-label="Loading"
    >
      {showToolbar ? (
        <div className="flex flex-wrap gap-2">
          <Skeleton className="h-8 w-48 max-w-full rounded-lg" />
          <Skeleton className="h-8 w-24 rounded-lg" />
          <Skeleton className="h-8 w-20 rounded-lg" />
        </div>
      ) : null}
      <div className="overflow-hidden rounded-2xl border border-border bg-card">
        {Array.from({ length: rows }).map((_, i) => (
          <div
            key={i}
            className="flex items-center gap-3 border-b border-border px-4 py-3 last:border-b-0"
          >
            <Skeleton className="size-9 shrink-0 rounded-full" />
            <div className="min-w-0 flex-1 space-y-2">
              <Skeleton className="h-4 w-40 max-w-[70%]" />
              <Skeleton className="h-3 w-56 max-w-full" />
            </div>
            <Skeleton className="hidden h-7 w-16 shrink-0 rounded-md sm:block" />
          </div>
        ))}
      </div>
      <span className="sr-only">Loading…</span>
    </div>
  )
}
